module.exports = "\n.titulo-processo-text-sub {\n  color: rgb(100, 100, 100);\n  font-size: 15px;\n}\n\n@media (min-width: 600px) {\n  .titulo-processo-text-sub {\n    font-size: 20px;\n  }\n}\n\n@media (min-width: 1250px) {\n\n  .titulo-processo-text-sub {\n    font-size: 25px;\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/historico-escolar/historico-escolar.component.css
// module id = ./src/app/historico-escolar/historico-escolar.component.css
// module chunks = main